import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { walletService, WalletType, type Wallet } from "@/services/walletService"
import { authService } from "@/services/authService"
import { useAuthStore } from "@/store/authStore"

export const WALLETS_KEY = ["wallets"] as const

/** Carteiras da pessoa; a ativa decide o que todas as telas mostram (ADR-021). */
export function useWallets() {
  return useQuery({ queryKey: WALLETS_KEY, queryFn: walletService.getAll, staleTime: 5 * 60_000 })
}

/** Troca a carteira ativa e recarrega tudo: cada tela passa a mostrar os dados da nova carteira. */
export function useActivateWallet() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => walletService.activate(id),
    onSuccess: () => queryClient.invalidateQueries(),
    onError: () => toast.error("Não foi possível trocar de carteira."),
  })
}

export const walletLabel = (w: Pick<Wallet, "type" | "name">) => (w.type === WalletType.Personal ? "Pessoal" : w.name)

/**
 * Depois de entrar ou sair de um grupo: o plano efetivo muda (ADR-021), então atualiza a pessoa e recarrega tudo.
 */
export function useRefreshAfterGroupChange() {
  const queryClient = useQueryClient()
  return async () => {
    try { useAuthStore.getState().setAuth(await authService.me()) } catch { /* o próximo /auth/me corrige */ }
    await queryClient.invalidateQueries()
  }
}
